document.addEventListener('DOMContentLoaded', () => {
  const cards = Array.from(document.querySelectorAll('.product-card'));
  if (!cards.length) return;

  const titles = cards.map(card => card.querySelector('.title-reviews-wrap'));

  function equalizeTitleHeights() {
    titles.forEach(title => {
      if (title) title.style.height = 'auto';
    });

    const cardMetrics = cards.map((card, i) => ({
      top: card.offsetTop,                           
      height: titles[i] ? titles[i].offsetHeight : 0
    }));

    let currentRowTop = cardMetrics[0].top;
    let rowTitles = [];
    let rowHeights = [];

    cardMetrics.forEach((metric, i) => {
      if (Math.abs(metric.top - currentRowTop) > 1) {
        applyMaxHeight(rowTitles, rowHeights);
        rowTitles = [];
        rowHeights = [];
        currentRowTop = metric.top;
      }

      rowTitles.push(titles[i]);
      rowHeights.push(metric.height);
    });

    applyMaxHeight(rowTitles, rowHeights);
  }

  function applyMaxHeight(rowTitles, rowHeights) {
    const maxHeight = Math.max(...rowHeights);
    rowTitles.forEach(title => {
      if (title) title.style.height = `${maxHeight}px`;
    });
  }

  let resizeFrame;
  function onResize() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(equalizeTitleHeights);
  }

  equalizeTitleHeights();
  window.addEventListener('resize', onResize);
});
